<template>
    <div>
        <b-overlay :show="loaded" rounded="sm">
        <b-row>
                <div class="mt-5 d-inline-block col-6">
                    <h3 class="mobile-font">{{$translate('holidays')}}</h3>
                </div>
                <div class="d-flex d-inline-block col-6 align-items-center justify-content-end mt-3">
                    <span class="me-2 mobile-font">{{ $translate('add_holiday') }}</span>
                    <div class="Click-here"></div>
                    <b-button id="add-holiday" variant="blue-icon"  @click=" 
                model = {}
                isModalVisible = true
                " v-b-tooltip.hover :title="$addLabel()"><img src="@/assets/images/icon/gradient-add.svg"></b-button>
                &nbsp;  &nbsp;
                <b-button id="import-holiday" variant="blue-icon"  @click="openModal()" v-b-tooltip.hover :title="$addLabel()"><img src="@/assets/images/icon/import.svg"></b-button>
                   
                  
                 
        </div>
        </b-row>
        <b-modal
        id="order-template-export"
        @ok="submitForm"
        header-class="p-0"
        footer-class="d-flex justify-content-center border-0"
        content-class="custom-model-wrap"
      >
        <template #modal-title>
          <div class="title-block text-center p-2">{{ $translate('holidays') }}</div>
          <div class="close-btn" @click="cancel()">x</div>
        </template>
        <form class="my-3 py-3" @submit.stop.prevent="submitForm">
          <b-row>
            <a href="javascript:void(0)" id="export-sample-file" title="Import" class="decoration-off text-success" @click="exportSampleFile">
              <i class="fas fa-file-excel fa-lg me-2"></i>{{ $translate('download_holiday_file') }}
            </a>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12" class="mb-3">
              <label for="file-input"><strong>{{ $translate('upload_holiday_file') }}</strong></label>
              <input type="file" id="file-input" @change="handleFileUpload" class="form-control mt-2" required />
            </b-col>
          </b-row>
        </form>
        <template #modal-footer="{ ok, cancel }">
          <b-button id="import-file-btn" size="sm" variant="info" @click="ok()">{{ $translate('import') }}</b-button>
          <b-button id="cancel-model-btn" size="sm" variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>
        </template>
      </b-modal>
        <b-modal v-model="isModalVisible" id="message-modal" hide-footer :close-on-backdrop="false" class="pt-8" centered
            header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
            <template #modal-title>
                <div class="title-block text-center p-2 m-0">
                    {{ model.id ? $translate('edit_holiday') : $translate('add_holiday') }}
                </div>
            </template>
            <b-row class="mt-3">
                <b-col cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('title') }}</strong></label>
                    <b-form-input id="input-title" class="test-input-title" type="text" v-model="model.title" name="title" required
                    ></b-form-input>
                </b-col>
                <!-- <b-col cols="12" class="mt-3">
                    <label><strong>{{ $translate('holiday_type') }}</strong></label>
                </b-col>
                <b-col cols="auto" class="mb-3">
                    <b-form-radio
                        v-model="model.day_type"
                        name="day_type"
                        value="holiday"
                        class="mx-1"
                    >&nbsp;{{$translate('holiday')}}</b-form-radio>
                </b-col>
                <b-col cols="auto" class="mb-3">
                    <b-form-radio
                        v-model="model.day_type"
                        name="day_type"
                        value="weekly"
                        class="mr-2"
                    >&nbsp;{{$translate('weekly')}}</b-form-radio>
                </b-col> -->
            </b-row>
            <b-col cols="12"  v-if="model.day_type === 'weekly'" class="mt-3">
                <label class="mb-3"><strong>{{ $translate('days') }} </strong></label>
                <b-form-select
                id="select-days"
                v-model="model.day_of_week"
              >
                <option value="Sunday">Sunday</option>
                <option value="Monday">Monday</option>
                <option value="Tuesday">Tuesday</option>
                <option value="Wednesday">Wednesday</option>
                <option value="Thursday">Thursday</option>
                <option value="Friday">Friday</option>
                <option value="Saturday">Saturday</option>
              </b-form-select>
                 
            </b-col>
            <b-col v-else cols="12" class="mt-3">
                <label class="mb-3"><strong>{{ $translate('date') }} </strong></label>
                <b-form-input id="input-date"  class="test-input-date"  type="date" v-model="model.date" name="title" required
                ></b-form-input>
            </b-col>
            
               
            <b-col cols="12" class="mt-3">
                <label class="mb-3"><strong>{{ $translate('notes') }}</strong>
                </label>
                <b-form-textarea id="input-instructions"  class="test-input-notes"  v-model="model.notes"
                    :placeholder="$translate('enter_instructions')" rows="3"></b-form-textarea>
            </b-col>
          
           
            <div class="d-flex justify-content-center mt-3">
                <b-button id="add-update-record-btn" size="sm" @click="createHoliday" class="btn-fw me-3" 
                     variant="info">{{ model.id
                        ? $translate('update') : $translate('add') }}</b-button>
                <b-button id="close-record-btn" size="sm" @click="isModalVisible = false" variant="info" class="btn-fw">{{ $translate('close')
                }}</b-button>
            </div>
        </b-modal>
        
        <b-col class="page-block">
            <strong>
                {{ $translate("page") }}: {{ pagination.page }}
                {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                {{ pagination.total }}
            </strong>
        </b-col>
        
        <b-row>
            <b-col md="12"  class="mobile-table">
                <b-table id="orderTable" :items="holidays" :fields="fields" :per-page="itemsPerPage"
                :current-page="currentPage" :busy="tableLoading" responsive show-empty
                    ref="selectableTable"  >
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <!-- <strong>{{ $translate('loading') }}</strong> -->
                        </div>
                    </template>
        
                    <template #empty>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
                    <template #emptyfiltered>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
        
                    <template #cell(actions)="{ item }">
                        <div class="d-flex">
                            <b-button :id="'view-record-btn-'+item.id"  @click="viewItem(item)" class="me-2 test-view-record-btn" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg">
                            </b-button>
                            <b-button variant="pink-button"
                                class="test-delete-record-btn"
                                :id="'delete-record-btn-'+item.id" 
                                @click="deleteSchedule(item.id)"
                                ><img
                                    src="@/assets/images/icon/delete.svg"></b-button>
                        </div>
                    </template>
        
                    <template #cell(id)="{ index }">
                        <p>
                            {{ index + 1 }}
                        </p>
                    </template>
        
                  
                </b-table>
            </b-col>
        </b-row>
     
        <b-row>
            <b-col>
                <b-pagination
                    class="justify-content-center mt-4"
                    v-model="pagination.page"
                    :total-rows="pagination.total"
                    :per-page="pagination.pageSize"
                    aria-controls="customerTable"
                    :prev-text="$translate('previous')"
                    :next-text="$translate('next')"
                    pills
                    align="center"
                ></b-pagination>
            </b-col>
        </b-row>
        </b-overlay>
    </div>
</template>

<script>
// import moment from 'moment'
import popupMixins from '@/mixins/popupMixins';
import permissionsMixins from '@/mixins/permissionsMixins';
import utilityMixins from "@/mixins/utilityMixins";
import { debounce } from 'lodash'
import download from '@/assets/images/icon/import.svg';

export default {
    name: 'asset-schedule',
    components: {
        
    },  
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    data() {
        return {
            download: download,
            searchedDocument: "",
            model: {},
            isModalVisible: false,
            scheduleCreated: false,
            tableLoading: false,
            submitting: false,
            itemsPerPage: 15,
            currentPage: 1,
            loaded:true,
            filters: {
               
                queryOptionsValue: 'starts_with',
            },
            leaves : null,
          
        }
    },
    props: {
        viewMode: { type: Boolean, default: false },
        crm: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
      

    },
    filters: {
        // displayTime(date) {
        //     const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        //     console.log('timezone', timezone)
        //     if (date) {
        //         return new Date(date).toLocaleString('en-US', {
        //             timeZone: timezone,
        //         })
        //     } else {
        //         return ''
        //     }
        // },
    },
    computed: {
        componentName() {   
       
                return this.$translate('holiday');
           
        },
        fields() {


            return [
              
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    class: 'actionButton_class',
                },
                {
                    key: 'title',
                    label: this.$translate('title'),
                    
                },
                // {
                //     key: 'day_type',
                //     label: this.$translate('holiday_type'),
                //     formatter: (value) => value.replace(/\b\w/g, char => char.toUpperCase()),
                   
                // },
                // {
                //     key: 'day_of_week',
                //     label: this.$translate('day_of_week'),
                 
                   
                // },
                {
                    key: 'date',
                    label: this.$translate('date'),
                   
                   
                },
                
             
                {
                    key: 'notes',
                    label: this.$translate('notes'),
                   
                }
              
                
            ]
        },
      
        holidays() {
            console.log('data----------', this.$store.state.holiday.documents)
            return this.$store.state.holiday.holidays
        },
      
    
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.holiday.pagination || { page: 1 };
        },
    
    },
    watch: {
        // 'assetSchedules': {
        //     handler: function (schedules) {
        //         this.$store.dispatch('assetScheduleStore/load', schedules)
        //     },
        //     deep: true,
        // },
       
       "pagination.page": function (val) {
            console.log('page-----',val)
            this.doSearch();
        },
    },
    async mounted() {
        // const { notes } = this.order
        // const schedule_data = this.assetSchedules
        // this.scheduleCreated = false
        // this.$store.dispatch('assetScheduleStore/load', schedule_data || [])
        this.doSearch();
       
    },
    methods: {

        queryOptionsValue(val) {
            console.log("gettttt", val)
            this.filters.queryOptionsValue = val
            this.lookupDocuments()
        },
        setDocument(document) {
            console.log('assets-is',document);
            this.model.master_document_id = document.id;
         
           
        },
      
        getLabel(value) {
            const label =
                value == "task_title"
                ? this.crm
                    ? this.$translate("task_title")
                    : this.$translate("name")
                : this.$translate(value);
            return label;
        },
        viewItem(item) {
            console.log('this is callled',item);
            this.model = { ...item }
            // this.searchedDocument = this.model.master_document? this.model.master_document.name : "";
            // this.model.master_document_id =  this.model.master_document.id;
            this.isModalVisible = true
        },

   

    async createHoliday() {
    let isError = false; 
    try {
        // const { model } = this;
        let label = "";

       
        // if (!model.name || !model.frequency || !model.order_template_id || !model.next_service_date) {
        //     throw new Error(this.$translate("schedule_error"));
        // }

        if (this.model.id) {
            label = this.$translate('updated');
            await this.$store.dispatch('holiday/updateHoliday', {
                schedule: this.model,
               
            });
        } else {
            label = this.$translate('created');
            await this.$store.dispatch('holiday/addHoliday', {
                schedule: this.model,
                
            });
        }

       
       

        this.scheduleCreated = true;

        
        await this.$store.dispatch('holiday/fetchholidays');
       

        
        await this.doSearch();
        this.genericToast(
            this.componentName,
            label,
            'success',
            `${this.componentName} ${this.$translate('save_alert')}`
        );

      
    } catch (err) {
       
        this.doToast(
            this.$translate("error"),
            err.message,
            "danger"
        );
        isError = true; 
    } finally {
       
        if (!isError) {
            this.isModalVisible = false;
        }
    }
},


        async doSearch() {
          
            let {
                
                pagination: { page },
                
            } = this
          
          
            page = parseInt(page) || 1;

            this.tableLoading = true
            this.loaded = true;
            try{
                
                await this.$store.dispatch('holiday/fetchholidays', {
                    page ,
        
                })
            } catch(err) {
                console.log('fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
                this.loaded = false;
            }
        },
        // deleteMessage(hash) {
        //     this.$store.dispatch('assetScheduleStore/delete', hash)
        //     this.genericToast(
        //         this.componentName,
        //         this.$translate('deleted'),
        //         'success',
        //         `${this.componentName} ${this.$translate('delete_alert')}`
        //     )
        //     this.$emit('success', this.componentName, this.$translate('deleted'))
        // },

        async deleteSchedule(scheduleId) {
            const confirmed = confirm('Are you sure you want to delete this holiday?');

            // Proceed only if the user confirms
            if (confirmed) {
                // const { model } = this;
                await this.$store.dispatch('holiday/deleteHoliday', {
                    schedule: scheduleId,
                });
                // Fetch the updated list of asset schedules
                await this.doSearch();
                this.genericToast(
                this.componentName,
                this.$translate('deleted'),
                'success',
                `${this.componentName} ${this.$translate('delete_alert')}`
               )
            }
        },
        lookupDocuments: debounce(function () {
            // in practice this action should be debounced
            let { searchedDocument: query, filters } = this
            delete filters.customer_id;
            query = query.split('-')[0] 
            // this.$store.dispatch('master_document/fetch_data', {  query, filters })
        }, 500),
    async submitForm() {
      const formData = new FormData();
      formData.append('leaves', this.leaves);

      try {
        this.updating = true;
        await this.$store.dispatch('holiday/excelImport', formData);
        await this.doSearch();
        this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`);
       
      } catch (error) {
        this.doToast(this.$translate('error'), error.message, 'danger');
        this.updating = false;
      }
    },
    async exportSampleFile() {
      try {
        this.updating = true;
        await this.$store.dispatch('holiday/sampleExcel');
      } catch (error) {
        this.doToast(this.$translate('error'), error.message, 'danger');
      } finally {
        this.updating = false;
      }
    },
    handleFileUpload(event) {
      this.leaves = event.target.files[0];
    },
    async openModal() {
      this.$bvModal.show('order-template-export');
    },
       
    },
}
</script>

<style>
.text-wrap {
    white-space: normal !important;
}

.created_at_class,
.user_id_class {
    width: 20% !important;
}

.id_class {
    width: 2% !important;
}

.actionButton_class {
    width: 8% !important;
}
</style>
